import React from "react";
import { EntityPickerModal as ImportedEntityPickerModal } from "@adsk/acc-reference-picker";

export default (props: any) => {
  return <ImportedEntityPickerModal {...props} />;
};
